import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable } from 'rxjs';
import * as CryptoJS from 'crypto-js';
import { GlobalVariable } from '../helpers/settings';

@Injectable()
export class SecurityInterceptor implements HttpInterceptor {
	private secretKey: string = GlobalVariable['SECRET'];

	intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
		const queryParams = req.params.keys().reduce((acc, key) => {
			acc[key] = req.params.get(key);
			return acc;
		}, {} as { [key: string]: string | null });

		if (Object.keys(queryParams).length > 0) {
			const encryptedData = this.encryptQueryParams(queryParams);
			let newParams = req.params;
			// Remove all old query params
			Object.keys(queryParams).forEach(key => {
				newParams = newParams.delete(key);
			});

			newParams = newParams.append('params', encryptedData);
			const clonedRequest = req.clone({
				params: newParams
			});
			return next.handle(clonedRequest);
		} else {
			return next.handle(req);
		}
	}

	private encryptQueryParams(queryParams: { [key: string]: string | null }): string {
		const jsonParams = JSON.stringify(queryParams);
		const encrypted = CryptoJS.AES.encrypt(jsonParams, this.secretKey).toString();
		return encodeURIComponent(encrypted);
	}
}
